import { useState } from "react";
import { Link } from "react-router-dom";
import InfoLayout from "../components/landing/InfoLayout";
import { FREE_PRODUCT_LIMIT, PRO_PRICE, PRO_TRIAL_DAYS } from "../plans";

const groups = [
    {
        title: "Planes y pagos",
        faqs: [
            ["¿El plan Gratis es gratis de verdad?", `Sí. Tenés tu catálogo con QR y hasta ${FREE_PRODUCT_LIMIT} productos sin pagar nada y sin cargar tarjeta. Tu catálogo muestra la marca “Hecho con MiQRapp”.`],
            ["¿Qué suma el plan Pro?", "Productos ilimitados y tu catálogo sin la marca de MiQRapp. Todo lo demás (QR, link, colores y categorías) está en los dos planes."],
            ["¿Cómo funciona la prueba de Pro?", `Te suscribís desde tu cuenta con Mercado Pago y usás Pro ${PRO_TRIAL_DAYS} días sin cargo. Después se cobra ${PRO_PRICE} por mes de forma automática, sin permanencia mínima.`],
            ["¿Cómo se paga?", "Con Mercado Pago, como un débito automático mensual. MiQRapp no ve ni guarda los datos de tu tarjeta."],
            ["¿Cómo cancelo Pro?", "Desde tu cuenta entrás a “Gestionar el pago en Mercado Pago” y cancelás la suscripción cuando quieras. No se hacen más cobros y tu cuenta vuelve al plan Gratis."],
            ["¿Qué pasa con mis productos si vuelvo al plan Gratis?", `No se borra nada. Tu catálogo muestra los primeros ${FREE_PRODUCT_LIMIT} productos y vuelve a llevar la marca de MiQRapp. Si reactivás Pro, se ven todos de nuevo.`]
        ]
    },
    {
        title: "Tu catálogo",
        faqs: [
            ["¿Mis clientes tienen que bajar una app?", "No. Escanean el QR con la cámara del celular o entran a tu link, y el catálogo se abre en el navegador, en el celu o en la compu."],
            ["¿Cómo agrego, edito o elimino productos?", "Desde la sección Productos de tu cuenta. Cada producto lleva foto, descripción, precio y categoría, y también podés marcarlo como agotado sin borrarlo."],
            ["¿Puedo personalizar el diseño?", "Sí. Elegís una paleta o los colores de fondo, letras y botones, y ves cómo queda antes de guardar. También sumás tu logo, dirección, teléfono y horarios."],
            ["¿Lo puedo compartir por redes o WhatsApp?", "Sí. Desde tu cuenta copiás el link de tu catálogo o lo mandás directo por WhatsApp. El QR también lo podés compartir como imagen."],
            ["¿Sirve para mi rubro?", "Sirve para restaurantes, bares, comercios, peluquerías y profesionales: cualquiera que quiera mostrar productos o servicios con precio."]
        ]
    },
    {
        title: "Tu código QR",
        faqs: [
            ["¿Cómo genero el QR?", "No tenés que hacer nada. Apenas cargás los datos de tu negocio, el QR se genera solo y ya abre tu catálogo."],
            ["¿El QR cambia si actualizo el catálogo?", "No. Lo imprimís una sola vez: aunque cambies productos o precios, el mismo QR siempre abre tu catálogo actualizado."],
            ["¿Dónde descargo o imprimo mi QR?", "En la sección QR de tu cuenta, en cualquier plan. Lo bajás en PNG o imprimís un cartel listo para la mesa o la vidriera."]
        ]
    },
    {
        title: "Tu cuenta",
        faqs: [
            ["¿Puedo entrar con Google?", "Sí. Podés crear tu cuenta y entrar con Google o con tu email y una contraseña."],
            ["¿Puedo cambiar el link de mi catálogo?", "El nombre de usuario que elegís al crear tu negocio es el link del catálogo y del QR, por eso después no se puede cambiar. Elegilo con cuidado."],
            ["¿Cómo borro mi cuenta?", "Escribinos a contacto@miqrapp.com desde el email de tu cuenta y la damos de baja junto con los datos de tu negocio."],
            ["¿Qué hago si tengo un problema?", "Escribinos a contacto@miqrapp.com contando qué pasó y te ayudamos."]
        ]
    }
];

// Datos estructurados para que Google entienda la página como preguntas frecuentes.
const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: groups.flatMap((group) => group.faqs.map(([question, answer]) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: { "@type": "Answer", text: answer }
    })))
};

const FAQ = () => {

    const [open, setOpen] = useState("0-0");

  return (
    <InfoLayout
        title="Preguntas frecuentes - MiQRapp"
        path="/preguntas-frecuentes"
        jsonLd={faqJsonLd}
        description="Respuestas sobre los planes, el pago con Mercado Pago, el código QR y cómo armar tu catálogo en MiQRapp."
        narrow
        eyebrow="Ayuda"
        heading="Preguntas frecuentes"
        subheading="Todo lo que necesitás saber para armar tu catálogo, compartir tu QR y elegir tu plan."
    >
        <section className="lp-section lp-info-body">
            <div className="lp-container lp-faq-page">
                {
                    groups.map((group, g) => (
                        <div key={group.title} className="lp-faq lp-faq-group">
                            <h2 data-reveal>{group.title}</h2>
                            {
                                group.faqs.map(([question, answer], i) => {
                                    const key = g + "-" + i;
                                    const isOpen = open === key;
                                    return (
                                        <div key={question} className="lp-faq-item" data-reveal style={{ "--d": (i * 50) + "ms" }}>
                                            <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : key)}>
                                                {question}
                                                <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
                                            </button>
                                            <p hidden={!isOpen}>{answer}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    ))
                }

                <div className="lp-info-cta" data-reveal>
                    <div>
                        <h2>¿No encontraste tu respuesta?</h2>
                        <p>Escribinos y te respondemos a la brevedad.</p>
                    </div>
                    <div className="lp-info-cta-actions">
                        <a href="mailto:contacto@miqrapp.com" className="lp-btn lp-btn-secondary">Escribinos</a>
                        <Link to="/register" className="lp-btn lp-btn-primary">Crear mi catálogo gratis</Link>
                    </div>
                </div>
            </div>
        </section>
    </InfoLayout>
  )
}

export default FAQ
